import React, { Fragment } from 'react';
import { Create, List, Datagrid, TextField,  BooleanInput, Edit,SimpleForm,DisabledInput, Toolbar, SaveButton   } from 'react-admin';
import {   NumberInput, TextInput ,   ReferenceInput , ImageInput, SelectInput , EmailField, ImageField, BooleanField  } from 'react-admin';

import LinkToRelatedDocuments from './components/LinkToRelatedDocuments.js';
import ClientLogo from './components/clientLogo.js';
import FullClientLogo from './components/fullClientLogo.js';

import {   EditButton  } from 'react-admin';
import { FormDataConsumer } from 'react-admin';

const styles = {
    flex: { display: 'flex'  },
};

///bulkActionButtons={null}

export const ClientList = props => (
    <List {...props} >
        <Datagrid   >
            <EditButton />
            <LinkToRelatedDocuments label="View docs"/>
            
            <TextField source="id" />
            <ClientLogo />
            <TextField source="name"   label="Company name" />
            <TextField source="contact" />
            <EmailField source="email" label="Email" />
            <TextField source="phone" />
             
            <BooleanField source="active" />
        </Datagrid>
    </List>
);

const PostEditToolbar = props => (
    <Toolbar {...props} >
        <SaveButton />  
    </Toolbar>
);
///
export const ClientCreate = props => (
    <Create {...props}>
        <SimpleForm validate={validateClientCreation} redirect="list" >
            <div  style={styles.flex} fullWidth  >
                <DisabledInput source="id"  fullWidth />
                <DisabledInput source="user" defaultValue={JSON.parse(localStorage.getItem("user")).id} fullWidth label='Created by'  />
            </div>
            <div  style={styles.flex} fullWidth  >
                <TextInput source="name" label="Company name" fullWidth />
                <ReferenceInput source="type" reference="client_types"  label="Client type" allowEmpty={true} resource="client_types"   >
                   <SelectInput optionText="description"  />
                </ReferenceInput>
            </div>
            <TextInput source="contact"  fullWidth />
            <div  style={styles.flex} fullWidth >
                <TextInput source="address_street" label="Street" fullWidth />
                <NumberInput   source="address_zipcode" label="Zipcode"   /> 
            </div>
            <div  style={styles.flex} fullWidth >
                <TextInput  source="address_city" label="City" fullWidth />
                <ReferenceInput source="country" reference="countries"  fullWidth allowEmpty={true} >
                   <SelectInput optionText="name" />
                </ReferenceInput>

                <FormDataConsumer>
                    {({ formData, dispatch   }) =>
                        <Fragment>

                             <ReferenceInput   source="state" reference="states" fullWidth  allowEmpty
                                                            filter={{ country: [ (    formData ? formData.country : 0  )  ] }} >
                                                       <SelectInput optionText="name" />
                                                    </ReferenceInput> 
                        </Fragment>
                    }
                </FormDataConsumer>
            </div>
            
            <div  style={styles.flex} fullWidth >
                <TextInput source="email" type="email" fullWidth />
                <TextInput source="phone" type="phone"   />
                <TextInput source="website" type="url" fullWidth />
            </div>
             


            <BooleanInput source="active" defaultValue={true}   />
            <TextInput source="password" type="password"  label="Password" fullWidth  />
             <ImageInput source="logo" label="Company logo (.png)" multiple={false}     >
                <ImageField source="src"   />
            </ImageInput>

        </SimpleForm>
    </Create>
);
///
export const ClientEdit = props => (
    <Edit title={<ClientTitle />} {...props} >
        <SimpleForm validate={validateClientCreation} toolbar={<PostEditToolbar />} redirect="list"  >
            <FullClientLogo />
            <div  style={styles.flex} fullWidth  >
                <DisabledInput source="id"  fullWidth />
                <DisabledInput source="user"  fullWidth label='Created by'  />
            </div>
            <div  style={styles.flex} fullWidth  >
                <TextInput source="name" label="Company name" fullWidth />
                <ReferenceInput source="type" reference="client_types"  label="Client type" allowEmpty={true} resource="client_types"   >
                   <SelectInput optionText="description"  />
                </ReferenceInput>
            </div>
            <TextInput source="contact" fullWidth  />
            <div  style={styles.flex} fullWidth >
                <TextInput source="address_street" label="Street" fullWidth />
                <NumberInput   source="address_zipcode" label="Zipcode"   /> 
            </div>
            <div  style={styles.flex} fullWidth >
                <TextInput  source="address_city" label="City" fullWidth  />
                <ReferenceInput source="country" reference="countries"  fullWidth allowEmpty={true} >
                   <SelectInput optionText="name" />
                </ReferenceInput>

                <FormDataConsumer>
                    {({ formData, dispatch   }) =>
                        <Fragment>

                             <ReferenceInput   source="state" reference="states" fullWidth  allowEmpty
                                                            filter={{ country: [ (    formData ? formData.country : 0  )  ] }} >
                                                       <SelectInput optionText="name" />
                                                    </ReferenceInput> 
                        </Fragment>
                    }
                </FormDataConsumer>

            </div>
            <div  style={styles.flex} fullWidth  >
                <TextInput source="email" type="email" fullWidth />
                <TextInput source="phone" type="phone"   />
                <TextInput source="website" type="url" fullWidth />
            </div>
            
            <BooleanInput source="active" defaultValue={true}   />
           <ImageInput source="logo" label="Company logo (.png)" multiple={false}     >
                <ImageField source="src"   />
            </ImageInput>

        </SimpleForm>
    </Edit>
);
 
const  validateEmail = (email) => {
  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

const validateUrl = (url) => {
  var re = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
  return re.test(url);
}

const validatePhone = (phone) => {
  var re = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  return re.test(phone);
}
 
const validateClientCreation = (values) => {
    const errors = {};

    if ( values.logo ){
        if ( values.logo.rawFile ){
            if (!( values.logo.rawFile.type === "image/png" || values.logo.rawFile.type === "image/jpeg"  )){
              errors.logo = ['The logo file must be png or jpg'];
            }
        }
    }

    if (!values.name) {
        errors.name = ['The name is required'];
    }
    if (!values.contact) {
        errors.contact = ['The contact name is required'];
    }
     if (!values.address_street) {
        values.address_street = " ";
    } 
    if (!values.address_city) {
        errors.address_city = ['The city is required'];
    }
    if (!values.address_zipcode) {
      values.address_zipcode = 0;
    } 
    if (!values.state) {
        errors.state = ['The state is required'];
    }
    if (!values.country) {
        errors.country = ['The country is required'];
    }
    if (!values.email) {
        errors.email = ['The email is required'];
    }
     if ( !validateEmail(values.email) ){
        errors.email = ['The email is invalid'];
    }
    if ( values.website ){
        if ( !validateUrl(values.website) ){
            errors.website = ['The website is invalid'];
        }
    } 
   
    if (!values.phone) {
        errors.phone = ['The phone is required'];
    }
    if ( !validatePhone(values.phone) ){
        errors.phone = ['The phone is invalid'];
    } 
    if (!values.type) {
        errors.type = ['The type is required'];
    } 
  
    if (!values.password) {
        errors.password = ['The password is required'];
    } 
    return errors
};

const ClientTitle = ({ record }) => {
    return <span>Client: {record ? `"${record.name}"` : ''}</span>;
};
